import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "/data/landun/workspace/codebase/node_modules/core-js/modules/es.array.iterator.js";
import "/data/landun/workspace/codebase/node_modules/core-js/modules/es.promise.js";
import "/data/landun/workspace/codebase/node_modules/core-js/modules/es.object.assign.js";
import "/data/landun/workspace/codebase/node_modules/core-js/modules/es.promise.finally.js";
import Vue from 'vue';
import App from '@/App.vue';
import store from '@/store';
import env from '@tencent/vft-common/env';
import '@/plugins';
import '@/mixin';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import { init } from '@/util';
import { initUserState, loginService } from '@vip-activity/business';
import Qrcode from './Qrcode.vue';
import { hackLitApp, hackWeibo, endTip } from './hack';
import EntryVideo from './components/EntryVideo/EntryVideo.vue';
Vue.use(VueAwesomeSwiper);
var vm = new Vue();
Vue.config.productionTip = false;

function getInitInfo() {
  return _getInitInfo.apply(this, arguments);
}

function _getInitInfo() {
  _getInitInfo = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            store.dispatch('getNow');
            store.dispatch('getOrderState');
            store.dispatch('getInviteUserInfo');
            store.dispatch('getInviteOrderInfo');
            _context2.next = 6;
            return initUserState();

          case 6:
            if (loginService.isLogin) {
              store.dispatch('hasBookAct');
              store.dispatch('getBuyList');
              store.dispatch('getHasDianboTicket');
            } else {
              store.commit('setState', {
                state: 'ticketReady',
                value: true
              });
            }

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getInitInfo.apply(this, arguments);
}

function isPhone() {
  return env.isIphone || env.isAndroid && !env.isApad;
}

if (isPhone()) {
  // 先加载视频
  new Vue({
    render: function render(h) {
      return h(EntryVideo);
    }
  }).$mount('#video'); // 执行initAPP

  init().then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (window.setting) {
              _context.next = 3;
              break;
            }

            vm.alert({
              msg: '配置加载失败，请刷新重试',
              confirm: function confirm() {
                window.location.reload();
              }
            });
            return _context.abrupt("return");

          case 3:
            // 极速版和微博hack
            try {
              hackLitApp(vm);
              hackWeibo(vm);
            } catch (e) {
              console.error(e);
            }

            _context.prev = 4;
            _context.next = 7;
            return Promise.all([getInitInfo()]);

          case 7:
            _context.next = 12;
            break;

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](4);
            console.log(_context.t0);

          case 12:
            new Vue({
              store: store,
              render: function render(h) {
                return h(App);
              }
            }).$mount('#app');
            endTip();

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 9]]);
  })));
} else {
  new Vue({
    store: store,
    render: function render(h) {
      return h(Qrcode);
    }
  }).$mount('#app');
}